import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRouter';
import './styles/global.css';
import { AuthProvider } from './context/AuthContext';
import { ErrorMessageProvider } from './context/ErrorMessageContext';
import { DeviceManagementProvider } from './context/DeviceManagementContext';
import { PageLayout } from './components';
import { ConfigProvider } from 'antd';
import darkThemeConfig from './styles/darkThemeConfig';
import { ThemeSwitchProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { SocketProvider } from './context/SocketContext';
import { DriverMonitoringSystemProvider } from './context/DriverMonitoringSystemContext';
import { ApiLinksProvider } from './context/ApiLinksContext';
import { HistoryAndReportsProvider } from './context/HistoryAndReportsContext';
import { UserRolesAndPermissionsProvider } from './context/UserRolesAndPermissionsContext';
import { CompanyManagementProvider } from './pages/ExecutiveConsole/components/hooks/useCompanyManagement';
import VersionManager from './VersionManager';

function App() {
  return (
    <Router>
      <ThemeSwitchProvider>
        <ConfigProvider theme={darkThemeConfig}>
          <NotificationProvider>
            <SocketProvider>
              <ApiLinksProvider>
                <AuthProvider>
                  <UserRolesAndPermissionsProvider>
                    <ErrorMessageProvider>
                      <CompanyManagementProvider>
                        <DeviceManagementProvider>
                          <DriverMonitoringSystemProvider>
                            <HistoryAndReportsProvider>
                              <CompanyManagementProvider>
                                <VersionManager />
                                <PageLayout>
                                  <AppRoutes />
                                </PageLayout>
                              </CompanyManagementProvider>
                            </HistoryAndReportsProvider>
                          </DriverMonitoringSystemProvider>
                        </DeviceManagementProvider>
                      </CompanyManagementProvider>
                    </ErrorMessageProvider>
                  </UserRolesAndPermissionsProvider>
                </AuthProvider>
              </ApiLinksProvider>
            </SocketProvider>
          </NotificationProvider>
        </ConfigProvider>
      </ThemeSwitchProvider>
    </Router>
  );
}

export default App;
